import { CreateCaregiverForm } from '@apps/web/components/caregivers/create_caregiver_form';
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
} from '@apps/web/components/ui/dialog';

type CreateCaregiverModalProps = {
    readonly open: boolean;
    readonly onOpenChange: (open: boolean) => void;
    readonly onComplete?: (
        caregivers: Array<{ id: string; name: string }>,
    ) => void;
    readonly maxCaregivers?: number;
};

export function CreateCaregiverModal({
    open,
    onOpenChange,
    onComplete,
    maxCaregivers,
}: CreateCaregiverModalProps) {
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="sm:max-w-[500px]">
                <DialogHeader>
                    <DialogTitle className="flex items-center gap-2">
                        Add Caregivers
                    </DialogTitle>
                </DialogHeader>
                <CreateCaregiverForm
                    onComplete={(newCaregivers) => {
                        onComplete?.(newCaregivers);
                        onOpenChange(false);
                    }}
                    onCancel={() => onOpenChange(false)}
                    maxCaregivers={maxCaregivers}
                />
            </DialogContent>
        </Dialog>
    );
}
